import { Component } from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'email-banner',
  templateUrl: './email-banner.component.html',
  styleUrl: './email-banner.component.scss'
})
export class EmailBannerComponent {

  bannerPreview: string | ArrayBuffer | null = null;
  public imgUrl = environment.ImageUrl;

  constructor(private auth: AuthServiceService) { }

  onBannerUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      let formData = new FormData();
      formData.append("image", input.files[0]);
      this.auth.uploadEmailImages(formData).subscribe((res: any) => {
        this.bannerPreview = res.body.url || '';
      });
    }
  }
}
